import React from 'react';
import BackButton from '../../components/BackButton';

import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import { Grid, Button } from '@material-ui/core';
import css from '../Cart/CouponBox/index.module.scss';
import DrawerPwa from '../../components/DrawerPwa';
import DialogBox from '../../components/DialogBox';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
export default function MinimumErrorPopup({
  amountAddMore,
  currency,
  goTocart,
  isTermsOpen,
  navigateToExplore,
  setIsTermsOpen,
  termsErrorView = false,
}) {
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);

  const heading = termsErrorView ? (
    <FormattedMessage id={'cart_couponnotapplied'} defaultMessage="Offer Not Applied" />
  ) : (
    <FormattedMessage id={'complete_order'} defaultMessage="Complete Your Order" />
  );
  const subHeading = () => {
    return (
      <>
        {termsErrorView ? (
          <>
            <FormattedMessage id={'offerErrorPopup'} defaultMessage="Complete Your Order" />
            <button onClick={() => setIsTermsOpen(!isTermsOpen)} className={css.detailsLink}>
              <FormattedMessage id="here" defaultMessage="here" />
            </button>
          </>
        ) : (
          intl.formatMessage(
            {
              id: 'minimum_amount',
              defaultMessage: 'Please add items worth {amount} more to apply this coupon',
            },
            { amount: `${amountAddMore} ${currency}` }
          )
        )}
      </>
    );
  };
  const redenerContent = () => {
    return (
      <div className={css.promoInfoWrapper}>
        <div className={css.headingWrapper}>
          <span className={css.headingOrder}>{heading}</span>
          <div className={css.containerModalClose}>
            <BackButton type="cross" handleBack={goTocart} />
          </div>
        </div>
        <div className={css.inner}>
          <Grid className={css.styleText}>
            <div>{subHeading()}</div>
          </Grid>
        </div>
        <div className={css.buttons}>
          <Button
            onClick={() => setIsTermsOpen(!isTermsOpen)}
            variant="outlined"
            color=""
            className={css.close}
          >
            <FormattedMessage id="review_coupon_terms" default="Review Coupon terms" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={navigateToExplore}
            className={css.explore}
          >
            <FormattedMessage id="navigation_exploremenu" default="Explore Menu" />
          </Button>
        </div>
      </div>
    );
  };
  return (
    <React.Fragment>
      {!isDesktop ? (
        <DrawerPwa
          hideCloseButton={true}
          variant="temporary"
          anchor="bottom"
          open={true}
          className={css.nobg}
          onClose={goTocart}
        >
          {redenerContent()}
        </DrawerPwa>
      ) : (
        <DialogBox hideCloseButton={true} size="sm" isOpen={true} onClose={goTocart}>
          {redenerContent()}
        </DialogBox>
      )}
    </React.Fragment>
  );
}
